import { IBaseMigrationItemCode } from '../../../interfaces';
import { BaseItemCodeToTreatmentMappingHandler } from '../../../mappings/base-item-code-to-treatment';
import {
  ADAItemSourceEntity,
  ExactADAItem,
  IExactADAItem,
} from '../../../exact/source/entities/ada-item';
import { PracticeWorksUsedItemCodeTreatmentSourceEntity } from '../../source/entities/used-item-code-treatments';

export class PracticeWorksItemCodeToTreatmentMappingHandler extends BaseItemCodeToTreatmentMappingHandler<
  ExactADAItem,
  ADAItemSourceEntity
> {
  sourceEntity = new PracticeWorksUsedItemCodeTreatmentSourceEntity();
  translateFn = (record: IExactADAItem): IBaseMigrationItemCode => ({
    id: record.itemCode,
    itemCode: record.itemCode,
    description: record.description ?? '',
  });
}
